<template>
  <div class="wm-container hidden-md-and-down">
    <div class="space-100"/>
    <el-text class="wm-title">为什么选择我们</el-text>
    <el-text class="wm-second-title margin-top-20">秉持以顾客为重的服务宗旨，全心全意致力于为您排忧解难</el-text>
    <el-row gutter="20" class="width-100 margin-top-30" justify="center">
      <el-col :span="4" class="wm-item">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_tuandui.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-30">
            专家团队保障
          </span>
          <span class="wm-item-text margin-top-15">
            多位专家级团队成员，具备10年的丰富从业经验，已成功为5000+中小企业提供了优质服务，凭借深厚的行业积淀，能够精准满足各类企业需求。
          </span>
        </div>
      </el-col>
      <el-col :span="4" class="wm-item">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_quanfangwei.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-30">
            多方位支持
          </span>
          <span class="wm-item-text margin-top-15">
            为您提供权威且针对性的指导建议，迅速且高质量地解决您企业所面临的信用问题。与您保持紧密沟通，实时向您同步每一项具体工作的进展情况。
          </span>
        </div>
      </el-col>
      <el-col :span="4" class="wm-item">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_gaozhiliang.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-30">
            高质量让您省心
          </span>
          <span class="wm-item-text margin-top-15">
            量身定制高质量的维护策略，以精准、高质量的行动，确保整个维护过程顺畅无阻，让企业信用维护变得轻松简单，获得客户广泛好评。
          </span>
        </div>
      </el-col>
      <el-col :span="4" class="wm-item">
        <div class="wm-item-img-bg">
          <img src="@/assets/home/whyme/img_feiyong.png" class="wm-item-img">
        </div>
        <div class="wm-item-title-line"/>
        <div class="wm-item-content">
          <span class="wm-item-title margin-top-30">
            费用实惠透明
          </span>
          <span class="wm-item-text margin-top-15">
            采用透明的核算方式，针对每一项具体事务进行单独商议定价，确保价格公开、清晰可查。若未能达成预期服务要求，承诺绝不收取费用。
          </span>
        </div>
      </el-col>
    </el-row>
    <div class="space-100"/>
    <div class="space-50"/>
  </div>
</template>

<script setup lang="ts">

</script>

<style scoped>
.wm-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  background: linear-gradient(#edf2ff, #edf2ff);
  z-index: 1;
}
.wm-title{
  font-size: 40px;
  font-weight: bold;
  color: #1a1a1a;
  justify-self: center;
  letter-spacing: 1px;
}

.wm-second-title{
  font-size: 14px;
  color: #444444;
  letter-spacing: 1px;
}

.wm-item {
  /*background-color: #ffffff;*/
  border-radius: 10px;
  width: 100%;
  height: 250px;
  display: flex;
  flex-direction: column;
  position: relative;
}
.wm-item-img-bg{
  width: 60px;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 30px;
  position: absolute;
  border: 1px solid #1b57ec;
  left: 20px;
}
.wm-item-img {
  width: 40px;
  height: 40px;
  /*box-shadow: 0 0 10px #1b57ec;*/
}

.wm-item-title-line {
  width: 100%;
  height: 15px;
  margin-top: 30px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  background-color: #1b57ec;
}
.wm-item-content{
  /*margin-top: 35px;*/
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
  display: flex;
  flex-direction: column;
  padding: 20px;
  box-sizing: border-box;
}
.wm-item-title{
  font-size: 15px;
  color: #2a2a2a;
  font-weight: bold;
  letter-spacing: 1px;
}
.wm-item-text{
  font-size: 13px;
  color: #444444;
  letter-spacing: 1px;
  line-height: 25px;
}
</style>
